export default {
  // 文件库
  library: {
    field1: 'organization files',
    field2: 'application files',
    field3: 'personal files',
    field6: 'project files',
    field4: 'my share space',
    field5: 'share with me',
    addFolder: 'new folder',
    seachFile: 'search for files',
    filename: 'file name',
    updatetime: 'updatetime',
    updateperson: 'update one',
    sharedperson: 'share one',
    managefolders: 'manage folders',
    setpermission: 'set permission',
    movefolder: 'move folder',
    sharedfile: 'shared file',
    sharedfolder: 'shared folder',
    delfile: 'delete',
    delfolder: 'delete folder',
    cancelsharing: 'cancel the shared',
    exitsharing: 'exit the shared',
    foldername: 'folder name',
    foldertype: 'folder type',
    publicTip: 'Public (this folder is visible to all members of the organization)',
    privateTip: 'Private (this folder is visible only to join members)',
    selectcolor: 'select a color',
    deltip: 'The files and subfolders in this folder will be deleted and unrecoverable.',
    moveto: 'move to...',
    selectfolder: 'select folder',
    folderdirectory: 'folder directory',
    canceltip:
      'The folder or file will not be visible to all Shared members after the share is cancelled.',
    canceldefine: 'Are you sure you want to cancel?',
    exitsharingtip: 'The folder or file will not be visible after exiting the share.',
    exittip: 'Are you sure you want to quit?',
    member_empty: 'members cannot be empty',
    selectdirectory: 'please select the directory',
    noauthority: 'You do not have permission to manipulate this folder',
    manage_empty: 'Administrator cannot be empty',
    err01: 'Data can only be searched by module',
    err02: 'Only item group searches for data',
    childmanage: 'the child administrator',
    name_empty: 'The folder name cannot be empty',
    name_length: 'The folder name must not exceed 12 characters',
    cancel_empty: 'the Shared member cannot be empty',
    filedetails: 'file for details',
    publiclinks: 'public links',
    uploadversion: 'upload new version',
    fileransfer: 'transfer to organization documents',
    move: 'move',
    copy: 'copy',
    share: 'share',
    sendchat: 'send to chat',
    magnif: 'magnify',
    shrink: 'shrink',
    rotate: 'anticlockwise',
    rotate1: 'right rotation',
    full: 'fullscreen view',
    downlint: 'downloads',
    hisedition: 'historical edition',
    downperson: 'downloader',
    downnum: 'download count',
    downtime: 'latest download time',
    currentversion: 'current version',
    first: 'first left',
    edition: 'edition ',
    linksharing: 'link to a shared',
    mailsharing: 'E-mail sharing',
    codesharing: 'QR code sharing',
    link: 'link address',
    copyaddress: 'copy the address',
    accesspwd: 'access the password',
    accessvalidity: 'access period',
    emailaddress: 'E-mail Address',
    sharinghistory: 'shared history',
    scanningtip: 'Scan the QR code above to share',
    copyto: 'copy to',
    delfiletip:
      'After deleting the file, the historical version is also deleted and cannot be recovered.',
    initiatechat: 'initiating a chat',
    privatechat: 'private chat',
    lookgroup: 'check the group',
    sendtip: 'send successful',
    second: 'time',
    pwd_error: 'Passwords can only be composed of four numbers',
    email_empty: 'the mailbox cannot be empty',
    email_error: 'incorrect mailbox format',
    copytoclipboard: 'copied to clipboard',
    sharenote: 'shared the file with you',
    extractpwd: 'please enter the extract password',
    extractfile: 'extracting files',
    downfile: 'download file',
    share2: 'the share of',
    libraryMnage: 'file base management',
    libraryNote:
      'manage the internal information of the company and share with team members at any time',
    fileset: 'file settings',
    disablefile: 'disable personal files',
    enablefile: 'enable personal files',
    companymanag: 'organization file manager',
    rootdirectory: 'root directory list',
    companydirectory: 'root directory of organization files',
    publicity: 'publicity',
    private: 'privacy',
    public: 'public',
    founder: 'founder',
    setmanage: 'Set up administrator',

    deltip2:
      'All the files deleted by the system are stored here. If you continue to delete, the files will be deleted from the database and cannot be recovered.',
    deltip3:
      'Deleting a file will delete it from the database. After deletion, the file cannot be recovered. Are you sure you want to hard delete the file?',
    deltime: 'delete time',
    delpeople: 'delete people'
  }
}
